import { Routes } from '@angular/router';

export const DEPOT_WEB_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'kaufenverkaufen',
  },
  {
    path: 'kaufenverkaufen',
    loadChildren: () => import('@zero/trade/feature-trade/web').then((m) => m.TRADE_WEB_ROUTES),
  },
  {
    path: 'konto',
    loadComponent: () => import('./pages/account-overview/account-overview.component').then((m) => m.AccountOverviewComponent),
  },
  {
    path: 'kundenwerbenkunden',
    loadChildren: () => import('@zero/self-service/feature-kwk/web').then((m) => m.KWK_WEB_ROUTES),
  },
  {
    path: 'einzahlen',
    loadComponent: () => import('./pages/deposit/deposit.component').then((m) => m.DepositComponent),
  },
];
